import { Col, Descriptions, Row } from "antd";
import React from "react";
import { formatCurrency } from "../shared/formatting";

const RenewalCoveragePanel = ({ selected }) => {
  return (
    <Row>
      <Col span={24}>
        {selected && (
          <Descriptions
            size="small"
            column={3}
            items={[
              {
                key: "tpllLimit",
                label: "Third Party Liability",
                children:
                  selected.TPLLLimit != null
                    ? formatCurrency(selected.TPLLLimit)
                    : "",
              },
              {
                key: "incomeTUPLimit",
                label: "Income Top Up",
                children:
                  selected.IncomeTUPLimit != null
                    ? formatCurrency(selected.IncomeTUPLimit)
                    : "",
              },
              {
                key: "roadStar",
                label: "Road Star",
                children: selected.RoadStar,
              },
              {
                key: "collisionDeductible",
                label: "Collision",
                children:
                  selected.CollisionDeductible != null
                    ? formatCurrency(selected.CollisionDeductible)
                    : "",
              },
              {
                key: "hitAndRunDeductible",
                label: "Hit And Run",
                children:
                  selected.HitAndRunDeductible != null
                    ? formatCurrency(selected.HitAndRunDeductible)
                    : "",
              },
              {
                key: "roadSidePlus",
                label: "Road Side Plus",
                children: selected.RoadSidePlus,
              },
              {
                key: "comprDeductible",
                label: "Comprehensive",
                children:
                  selected.ComprDeductible != null
                    ? formatCurrency(selected.ComprDeductible)
                    : "",
              },
              {
                key: "offHwyTPLLimit",
                label: "Off Hwy TPL",
                children:
                  selected.OffHwyTPLLimit != null
                    ? formatCurrency(selected.OffHwyTPLLimit)
                    : "",
              },

              {
                key: "lou",
                label: "Loss of Use Total/Daily",
                children: selected.LOU,
              },

              {
                key: "rcLdNvr",
                label: "RC/LD/NVR+",
                children: (() => {
                  const values = [
                    selected.RC,
                    selected.LD,
                    selected.NVR,
                  ].filter((value) => value !== null && value !== undefined);

                  if (
                    values.length === 0 ||
                    values.every((value) => value === "NO")
                  ) {
                    return "NONE";
                  }

                  return values.find((value) => value !== "NO") || "NO";
                })(),
              },
            ]}
          />
        )}
      </Col>
    </Row>
  );
};

export default RenewalCoveragePanel;
